<template>
  <section class="bottom-nav">
    <audio ref="audio" :src="audioUrl"></audio>
    <img
      class="img-item"
      v-for="(i, i_index) in 6"
      v-if="i_index != 4"
      :key="i_index"
      :src="choose == i_index ? imgUrl(i_index, true) : imgUrl(i_index, false)"
      @click="goPage(i_index)"
      alt=""
    />
  </section>
</template>


<script>
export default {
  data() {
    return {
      selectState: -1,
      audioUrl: require("../../assets/backMusic.wav"), //声音文件
    };
  },
  props: {
    choose: "",
  },

  components: {},

  mounted() {
    this.$nextTick(() => {
      document.addEventListener("UniAppJSBridgeReady", function () {
        // alert("jsbridge")
      });
    });
  },

  methods: {
    imgUrl(i, state) {
      let urlStr = state
        ? `https://images.jianshankeji.com/timepark/timeNew_${i}_${i}.png`
        : `https://images.jianshankeji.com/timepark/timeNew_${i}.png`;
      return urlStr;
    },
    goPage(n) {
      console.log(9999999, n, wx);
      this.$refs.audio.play(); //点击触发 点击音效
      switch (n) {
        case 0:
          wx.miniProgram.redirectTo({
            url: "/pages/intro/intro", // 小程序中页面的路径
          });
          break;
        case 1:
          wx.miniProgram.redirectTo({
            url: "/pages/business/business", // 小程序中页面的路径
          });
          break;
        case 2:
          wx.miniProgram.redirectTo({
            url: "/pages/resource/resource", // 小程序中页面的路径
          });
          break;
        case 3:
          wx.miniProgram.redirectTo({
            url: "/pages/project/project", // 小程序中页面的路径
          });
          break;
        // case 4:
        //   wx.miniProgram.redirectTo({
        //     url: "/pages/t2t3/t2t3", // 小程序中页面的路径
        //   });
        //   break;
        case 5:
          wx.miniProgram.redirectTo({
            url: "/pages/select/select", // 小程序中页面的路径
          });
          break;
        // case 4:
        //   wx.miniProgram.redirectTo({
        //     url: "/contact/contact", // 小程序中页面的路径
        //   });
        // break;

        default:
          break;
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.bottom-nav {
  position: fixed;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);
  width: 380px;
  height: 37px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .img-item {
    width: 45px;
    height: 35px;
    // &:nth-child(4) {
    //   width: 20px;
    // }
  }
}
</style>